module.exports = __webpack_public_path__ + "static/media/year-rank.04e2c95b.png";